import React, { useEffect } from "react";
import Header from "../Component/Header";
import { Link } from "react-router-dom";
const AdmissionServing = () => {
  useEffect(() => {
    document.title = "UKG Admissions -  The Air Force School Subroto Park";
  }, []);
  return (
    <>
      <Header />
      <div className="innerslide">
        <ul className="breadcrumb">
          <li>
            <Link to="/"> Home</Link>{" "}
          </li>
          <li> Admissions </li>

          <li>Admission - Serving AF Personnel</li>
        </ul>
      </div>
      <div className="innersec">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <h1> Admission - Serving AF Personnel </h1>
            </div>
          </div>
          <div className="row">
            {/* <div className="col-lg-12">
                     <h6>No Vacancy Available for Admission in any Classes</h6> 
                    </div> */}
            <div className="col-lg-6">
              <div className="linktab">
                {" "}
                <Link
                  to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/SERVING_AIR_FORCE_PERSONNEL.pdf"
                  target="_blank"
                >
                  {" "}
                  ADMISSION NOTICE FOR WARDS OF SERVING AIR FORCE PERSONNEL
                </Link>{" "}
              </div>
            </div>
            {/*   <div className="col-lg-6">
                <div className="linktab"> <Link to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/ADMLISTVIII-AFCATEGORY.pdf" target="_blank">   ADMISSION LIST - VIII (AF CATEGORY)
                </Link> </div>
        </div>
          <div className="col-lg-6">
                <div className="linktab"> <Link to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/ADMLISTVII-AFCATEGORY.pdf" target="_blank">  ADMISSION LIST - VII (AF CATEGORY) 
                </Link> </div>
        </div>
          <div className="col-lg-6">
                <div className="linktab"> <Link to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/ADMLISTVI-AFCATEGORY.pdf" target="_blank">   ADMISSION LIST - VI (AF CATEGORY)
                </Link> </div>
        </div>
          <div className="col-lg-6">
                <div className="linktab"> <Link to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/ADMLISTV-AFCATEGORY.pdf" target="_blank">   ADMISSION LIST - V (AF CATEGORY)
                </Link> </div>
        </div>
          <div className="col-lg-6">
                <div className="linktab"> <Link to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/ADMLISTIV-AFCATEGORY.pdf" target="_blank">  ADMISSION LIST - IV (AF CATEGORY) 
                </Link> </div>
        </div>
          <div className="col-lg-6">
                <div className="linktab"> <Link to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/ADMLISTIII-AFCATEGORY.pdf" target="_blank">   ADMISSION LIST - III (AF CATEGORY)
                </Link> </div>
        </div>
          <div className="col-lg-6">
                <div className="linktab"> <Link to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/ADMLISTII-AFCATEGORY.pdf" target="_blank"> ADMISSION LIST - II (AF CATEGORY)  
                </Link> </div>
        </div>
          <div className="col-lg-6">
                <div className="linktab"> <Link to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/ADMLISTI-AFCATEGORY.pdf" target="_blank"> ADMISSION LIST - I (AF CATEGORY)   
                </Link> </div>
        </div>
          <div className="col-lg-6">
                <div className="linktab"> <Link to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/DOCUMENTSREQUIRED.pdf" target="_blank">   DOCUMENTS REQUIRED AT THE TIME OF ADMISSION
                </Link> </div>
        </div>
          <div className="col-lg-6">
                <div className="linktab"> <Link to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/NEWADMISSIONFEE-AFCATEGORY.pdf" target="_blank">  NEW ADMISSION FEE (AF CATEGORY) 
                </Link> </div>
  </div> */}
          </div>
        </div>
      </div>
    </>
  );
};

export default AdmissionServing;
